export default __webpack_public_path__ + "media/components/Pages/Index/Images/student-4fa18aa5a7dd85870dd49ddf2c309328.jpg";